import React, {useContext, useRef, useState} from "react";
import styles from "./processCompareNodeProfile/ProcessCompareNodeProfile.module.scss";
import Collapsable from "../../../Componnets/Collapsable/Collapsable";
import NodeProfileWrapper from "../../../Componnets/NodeProfileWrapper/NodeProfileWrapper";
import appContext from "../../../../context/appContext";

const ProcessCompareNodeProfile = ({ index = 0, graph, data = [], title = '', filters, views, selectedFilter, selectedView, handleSetSelectedFilter, handleSetSelectedView, showNodeProfile, closeNodeProfile }) => {

    const context = useContext(appContext);
    const comparisonLayerColor = context.handleCompareColor();
    const [activeTab, setActiveTab] = useState({next: true});

    const previous = graph.filter(item => item.to === data[index].id).map(item => data.find(i => i.id === item.from));
    const next = graph.filter(item => item.from === data[index].id).map(item => data.find(i => i.id === item.to));

    const handleActiveTab = (param) => {
        if (!activeTab[param]) {
            setActiveTab(prevState => ({[param]: !prevState[param]}));
        }
    }

    const activitiesListRef = useRef(null);

    const executeScroll = () => {
        setTimeout(() => {
            activitiesListRef.current.scrollIntoView({behavior: 'smooth'});
        }, 100);
    }

    const handleShowCharts = (item) => {

        let mainLayerValue = 0;
        let comparisonLayerValue = 0;

        if (data[index].layer2) {
            const totalDuration = Math.max(Math.round(data[index].layer1.total_duration_sec), Math.round(data[index].layer2.total_duration_sec));
            const totalCaseFrequency = Math.max(Math.round(data[index].layer1.total_frequency.value), Math.round(data[index].layer2.total_frequency.value));
            const totalLoop = Math.max(Math.round(data[index].layer1.loop.value), Math.round(data[index].layer2.loop.value));

            if (data && item.value !== item.secValue) {
                if (data[index].layer2) {
                    mainLayerValue = parseInt(Math.round(100 / totalDuration * data[index].layer1[selectedView[item.secValue]])) || 0;
                    comparisonLayerValue = parseInt(100 / totalDuration * Math.round(data[index].layer2[selectedView[item.secValue]])) || 0;
                }
            } else {
                if (data[index].layer2) {
                    if (item.value === "caseFrequency") {
                        mainLayerValue = parseInt(Math.round(100 / totalCaseFrequency * data[index].layer1[selectedView[item.secValue]].value)) || 0;
                        comparisonLayerValue = parseInt(100 / totalCaseFrequency * Math.round(data[index].layer2[selectedView[item.secValue]].value)) || 0;
                    } else if (item.value === "rework") {
                        mainLayerValue = parseInt(Math.round(100 / totalLoop * data[index].layer1[selectedView[item.secValue]].value)) || 0;
                        comparisonLayerValue = parseInt(100 / totalLoop * Math.round(data[index].layer2[selectedView[item.secValue]].value)) || 0;
                    }
                }
            }
        }

        return (
            <div className={styles.content}>
                <div>
                    <div>Main Layer</div>
                    <div className={styles.barChartContainer}>
                        {
                            data &&
                                data[index].layer1[selectedView[item.value]].value
                        }
                        <div className={styles.barChart}>
                            <div style={{width: mainLayerValue + '%'}}></div>
                        </div>
                    </div>
                </div>
                <div>
                    <div>Layer 2</div>
                    <div className={styles.barChartContainer}>
                        {
                            data && data[index].layer2 &&
                                data[index].layer2[selectedView[item.value]].value
                        }
                        <div className={styles.barChart}>
                            <div style={{width: comparisonLayerValue + '%', background: comparisonLayerColor}}></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    if (data[index].layer2) {
        return (
            <div className={styles.ProcessCompareNodeProfile}>
                <NodeProfileWrapper topBorderColor={["#8A0FFF", comparisonLayerColor]} showNodeProfile={showNodeProfile} closeNodeProfile={closeNodeProfile}>
                    <div className={styles.topTitle}>
                        <div className={styles.title}>
                            <div>{ title }</div>
                            <div className={'d-flex align-items-center justify-content-center'}>
                                <div style={{background: comparisonLayerColor}} className={`d-flex align-items-center ${styles.halfLeft}`}>
                                    Lvl { data[index].layer2.total_frequency.thickness }
                                </div>
                                <div style={{background: "#8A0FFF"}} className={`d-flex align-items-center ${styles.halfRight}`}>
                                    Lvl { data[index].layer1.total_frequency.thickness }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id={"nodeProfileBody"} className={styles.nodeProfileScrollBody}>
                        <div>
                            <div className={styles.views}>
                                {
                                    views.map(item => (
                                        <div className={`${styles.viewCard}`}>
                                            <div style={{background: "rgb(138,15,255)", background: `linear-gradient(180deg, #8A0FFF 50%, ${comparisonLayerColor} 50%)`}} className={`d-flex align-items-center justify-content-center ${styles.icon}`}>
                                                { item.icon }
                                            </div>
                                            <div className={`${styles.info}`}>
                                                <div className={styles.title}>
                                                    { selectedView[item.value].replace("_", " ") }
                                                </div>
                                                { handleShowCharts(item) }
                                                <div className={`d-flex justify-content-between ${styles.items}`}>
                                                    {
                                                        item.items.map(view => (
                                                            <div
                                                                onClick={() => handleSetSelectedView(item.value, view.value, view.sec)}
                                                                className={selectedView[item.value] === view.value && styles.active}
                                                            >
                                                                { view.title }
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        <div className={`${styles.filters}`}>
                            <Collapsable title={"Filters"} disabled>
                                {
                                    filters.map(filter => (
                                        <div onClick={() => handleSetSelectedFilter(filter)} className={`align-items-center justify-content-center ${styles.filter} ${selectedFilter === filter && styles.active}`}>
                                            { filter }
                                        </div>
                                    ))
                                }
                                <div className={styles.text}>Cases <span>{selectedFilter}</span> with this activity</div>
                            </Collapsable>
                        </div>
                        <div ref={activitiesListRef} className={styles.activitiesList}>
                            <Collapsable executeScroll={executeScroll}  title={"Activities List"}>
                                <ul className={styles.tabs}>
                                    <li
                                        onClick={() => handleActiveTab('next')}
                                        className={`${styles.tab} ${styles.Tab} ${activeTab['next'] ? styles.active : ''}`}>
                                        <div className={'d-flex align-items-center'}>
                                            <div className={'ml-1'}>
                                                Next
                                            </div>
                                        </div>
                                    </li>
                                    <li
                                        onClick={() => handleActiveTab('previous')}
                                        className={`${styles.tab} ${styles.Tab} ${activeTab['previous'] ? styles.active : ''}`}>
                                        <div className={'d-flex align-items-center'}>
                                            <div className={'ml-1'}>
                                                Previous
                                            </div>
                                        </div>
                                    </li>
                                    <li className={`${styles.presentationSlider}`} role="presentation"></li>
                                </ul>
                                <div className={'mt-3'}>
                                    {
                                        activeTab && activeTab['next'] && next.map(item => <div className={styles.activityName}>{ item?.name }</div>)
                                    }
                                    {
                                        activeTab && activeTab['previous'] && previous.map(item => <div className={styles.activityName}>{ item?.name }</div>)
                                    }
                                </div>
                            </Collapsable>
                        </div>
                    </div>
                </NodeProfileWrapper>
            </div>
        )
    } else {
        return (
            <div className={styles.ProcessCompareNodeProfile}>
                <NodeProfileWrapper showNodeProfile={showNodeProfile} closeNodeProfile={closeNodeProfile}>
                    <div className={styles.topTitle}>
                        <div className={styles.title}>
                            <div>{ title }</div>
                            <div className={styles.warning}>There is no data to compare...</div>
                        </div>
                    </div>
                </NodeProfileWrapper>
            </div>
        )
    }
}

export default ProcessCompareNodeProfile;